module.exports = __webpack_public_path__ + "img/visit_summary.7875c876.svg";